import html2canvas from 'html2canvas';
import QRCode from './qrcode';
import { ZYToast } from '@zyf2e/adapt';

const documentWidth = window.document.documentElement?.getBoundingClientRect()?.width;
const getSize = () => {
  return documentWidth && documentWidth > 540
    ? documentWidth / 3.2
    : 128;
};

// eslint-disable-next-line class-methods-use-this
export const sleep = (ms) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};

// 通过 canFail，兼容头像加载失败的可能
// eslint-disable-next-line class-methods-use-this
export const fetchImage = (src, { canFail } = {}) => {
  return new Promise((resolve) => {
    if (!src) return resolve(null);
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    const timer = setTimeout(() => {
      // eslint-disable-next-line prefer-promise-reject-errors
      canFail
        ? resolve(null)
        : ZYToast.error(new Error('图片加载超时'));
    }, 10000);
    img.onload = () => {
      clearTimeout(timer);
      resolve(img);
    };
    img.onerror = () => {
      clearTimeout(timer);
      // eslint-disable-next-line prefer-promise-reject-errors
      canFail
        ? resolve(null)
        : ZYToast.error(new Error('图片加载失败'));
    };
    img.src = src;
  });
};

// eslint-disable-next-line class-methods-use-this
export const toBase64 = (img, outputFormat) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0);
  return canvas.toDataURL(outputFormat || 'image/jpg');
};

// 前端生成二维码
export const composeQrcode = ({ url }) => {
  try {
    const qrcode = new QRCode({
      render: 'canvas',
      text: url,
      size: getSize(),
      background: '#fff',
      foreground: '#333',
      pdground: '#333',
      imageSize: 100
    });
    return qrcode;
  } catch (error) {
    console.log(error);
    window.MITO.log({
      message: error.message,
      tag: '邀请有礼海报页'
    });
  }
};

export const html2Img = () => {
  return new Promise((resolve, reject) => {
    const shareContent = document.getElementById('canvas');

    // 会导致 popover 组件定位异常
    // window.pageYOffset = 0;

    // 滚动时，会导致生成图片不完整
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    html2canvas(shareContent, {
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#F65425',
      scrollY: 0
    }).then(canvas => {
      resolve(canvas.toDataURL());
    }).catch(error => {
      ZYToast.error(new Error('生成海报失败'));
      window.MITO.log({
        message: error.message,
        tag: '邀请有礼海报页'
      });
    });
  });
};
